/**
 * Theme of the block. Default is light
 */
export enum BlockTheme {
  light,
  dark,
}
